@if (model && model.organizationId) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <risk-linkable
            #linkable
            displayValueProp="name"
            [linked]="linked"
            [unlinked]="unlinked"
            [hideActions]="true"
            [orderByValueProperty]="true"
            (linkedChange)="linkedChanged($event)"
            [disabled]="!permissions.canLinkRisks"
        >
        </risk-linkable>
    }
} @else {
    <div>{{ 'datamanagement.selectOrganizationFirst' | transloco }}</div>
}
